import { serviceCreateClient, serviceFetchClient, serviceUpdateClient } from "../services/Client.service";
import EventEmitter from "../libs/Events.utils";
import store from "../store";
import constants from "../config/constants";


export const FETCH_INIT = 'FETCH_INIT_CLIENT';
export const FETCHED = 'FETCHED_CLIENT';
export const FETCHED_FAIL = 'FETCHED_FAIL_CLIENT';
export const FETCHED_FILTER = 'FETCHED_FILTER_CLIENT';
export const FETCH_NEXT = 'FETCH_NEXT_CLIENT';
export const FILTER = 'FILTER_CLIENT';
export const RESET_FILTER = 'RESET_FILTER_CLIENT';
export const SET_SORTING = 'SET_SORTING_CLIENT';
export const SET_FILTER = 'SET_FILTER_CLIENT';
export const SET_PAGE = 'SET_PAGE_CLIENT';
export const CHANGE_PAGE = 'CHANGE_PAGE_CLIENT';
export const CHANGE_STATUS = 'CHANGE_STATE_CLIENT';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_CLIENT';

export const CREATE_DATA = 'CREATE_CLIENT';
export const UPDATE_DATA = 'UPDATE_CLIENT';
export const DELETE_ITEM = 'DELETE_CLIENT';

export function actionFetchClients(index = 1, sorting = {}, filter = {}, shouldReset = false) {
    const request = serviceFetchClient({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionCreateClients(data) {
    const request = serviceCreateClient(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: 'Saved', type: 'success' });
                dispatch({ type: CREATE_DATA, payload: data.data })
            } else {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: data.message, type: 'error' });
            }
        })
    }
}

export function actionUpdateClients(data) {
    const request = serviceUpdateClient(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: 'Edited Successfully', type: 'success' });
                dispatch({ type: UPDATE_DATA, payload: data.data })
            } else {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: data.error, type: 'error' });
            }
        })
    }
}

export function actionDeleteClients(id) {
    const request = serviceFetchClient({ id: id });
    return (dispatch) => {
        dispatch({ type: DELETE_ITEM, payload: id })
    }
}



export function actionChangePageClients(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page })
    }
}


export function actionFilterClients(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}


export function actionChangeStatusClients(id, status) {
    return (dispatch) => {
        dispatch({ type: CHANGE_STATUS, payload: { id, status } });
    };
}

export function actionResetFilterClients() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageClients(page) {
    const stateData = store.getState().clients;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchClients(serverPage + 1, sortingData, { query, query_data: queryData }));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

